import { handleRequest } from "../utilities/requestHandler";

export const createSchedulerJob = (req_body) => 
    handleRequest("post", "/scheduler/create", req_body);

export const getAllSchedulerJobs = () => 
    handleRequest("get", "/scheduler/get_all_jobs");